import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { CommonService } from "src/app/core/services/common.service";
import { DefaultTargeting } from "src/app/models/campaigns";
import { TdspTrgtEditAction, trgtOperationOptions } from "src/app/models/common";
import { TdspStaticService } from "src/app/core/services/tdsp/tdsp-static.service";
import { TdspGeoService } from "src/app/core/services/tdsp/tdsp-geo.service";
import { MatDialog } from "@angular/material/dialog";
import { InformationBoxComponent } from "src/app/shared/information-box/information-box.component";
import { City, CountryObject, isValid, Region } from "src/app/models/tdsp/tdsp-line-item";
import { CdkDragDrop, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";
import { TdspLineItemService } from "src/app/core/services/tdsp/tdsp-line-item.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TdspCustomLocationService } from "src/app/core/services/tdsp/tdsp-custom-location.service";
import { ActionPreviewComponent } from "../../action-preview/action-preview.component";

@Component({
  selector: 'app-tdsp-geo-targeting',
  templateUrl: './tdsp-geo-targeting.component.html',
  styleUrl: './tdsp-geo-targeting.component.scss'
})
export class TdspGeoTargetingComponent {
  @Output() stepChange = new EventEmitter<any>();
  @Input() stepInput: any;

  dataSourceGeo: MatTableDataSource<any>;
  @ViewChild("geoPaginator") paginatorGeo: MatPaginator;
  @ViewChild("geoSort") sortGeo: MatSort;

  def_li_targeting: DefaultTargeting;

  geoPrurals = {
    country: "countries",
    city: "cities",
    region: "regions",
    metros: "metros",
  };

  search_params = {};
  isEdit: boolean = false;
  geoFilter;

  selectedGeoTab: "country" | "city" | "region" = "country";
  selectedGeoChip: "geo" | "dma" | "postal_codes" | "custom_location" | "weather_temperature" = "geo";
  displayColumnGeo: Array<any> = [];
  country_action: "include" | "exclude" | "" = "";
  region_action: "include" | "exclude" | "" = "";
  city_action: "include" | "exclude" | "" = "";
  zip_action: "include" | "exclude" | "" = "";

  allGeo: Array<any> = [];
  geoSearchTerm: string;
  geoObject: Array<CountryObject> = [];

  dataSourceMetro: MatTableDataSource<any>;
  @ViewChild("metroPaginator") paginatorMetro: MatPaginator;
  @ViewChild("metroSort") sortMetro: MatSort;

  dataSourceCustomLocation: MatTableDataSource<any>;
  @ViewChild("customLocationPaginator") paginatorCustomLocation: MatPaginator;
  @ViewChild("customLocationSort") sortCustomLocation: MatSort;


  allMetro: Array<any> = [];
  showMetroCode: boolean = false;
  displayColumnMetro: string[] = ["checkbox", "name", "key"];
  selectedMetro: Array<any> = [];
  metro_action: "include" | "exclude" | "" = "";
  dmaPageLength: number;
  pageLength;
  customLocs: Array<any> = [];

  selectedCountryIDForPostalCodes: number;
  allCountriesForPostalCodes = [];
  ctryToTarget: Array<any> = [];
  inputZipCodes: string;
  selectedZip: Array<any> = [];

  bulkEditTrgtAct: TdspTrgtEditAction;
  trgtOperations: Array<any> = [];
  selectedTrgts: Array<any> = [];
  selectedPostalCodes: Array<any> = [];

  temperatureMin: number;
  temperatureMax: number;
  selectedWeather: Array<any> = [];
  allAvailableWeather: Array<any> = [];
  lowGeoBid: number = 0.1;
  midGeoBid: number = 1;
  highGeoBid: number = 1.1;
  geoOptimization: boolean = false;
  isMediaPlan: boolean = false;
  globalParams;
  temperatureForm: FormGroup;
  search_custom_location_params = {};
  allCustomLocation: Array<any> = [];
  pageLengthCustomLocation: number;
  totalCustomLocationCount: number;
  selectedCustomLocation: Array<any> = [];
  displayCustomLocationColumnList: string[] = ["checkbox", "id", "name"];
  allowTemperatureTargeting: boolean;
  allowWeatherTargeting: boolean;
  bidFactorTooltip: string = `Bid factor is a way of telling “I want more impressions like this” by bid factoring over 1,
  and “I want fewer impressions like this” by bid factoring less than 1.

  Bid factors do two things. First, they signal to the platform your desire for more or less volume.
  Second, they signal to the platform that you’re willing to allocate more budget to those impressions either by increasing budget or bidding up or down to get that impression.

  Bid factor of 0 blocks delivery.

  Bid factors cannot be set if auto optimization is enabled for this targeting.`;

  weatherTooltip = `Serve ads based on
  real-time or forecasted weather conditions in the user's location. Ads are
  delivered only when specified weather criteria are met.`;

  temperatureTooltip =`Serve ads based on real-time or
  forecasted Temperature conditions in the user's location. Ads are delivered
  only when specified temperature criteria are met.`;

  constructor(
    public dialog: MatDialog,
    private tdspStaticService: TdspStaticService,
    private commonService: CommonService,
    private geoService: TdspGeoService,
    private tdspLineItemService: TdspLineItemService,
    private fb: FormBuilder,
    private customLocationService: TdspCustomLocationService
  ) {
    commonService.getIvtData.subscribe((res) => {
      this.customLocs = res.list;

    });
    this.temperatureForm = this.fb.group(
      {
        temperatureMin: [null, [Validators.min(-90), Validators.max(60)]],
        temperatureMax: [null, [Validators.min(-90), Validators.max(60)]],
      },
      { validators: this.maxGreaterValidator }
    );
    // Keep control-level error in sync for nicer UI feedback on Max field
    this.temperatureForm.valueChanges.subscribe(() => {
      const hasError = this.temperatureForm.hasError('maxLessThanMin');
      const maxCtrl = this.temperatureForm.get('temperatureMax');
      if (hasError) {
        maxCtrl?.setErrors({ ...(maxCtrl.errors || {}), maxLessThanMin: true });
      } else if (maxCtrl?.errors) {
        const { maxLessThanMin, ...rest } = maxCtrl.errors;
        maxCtrl.setErrors(Object.keys(rest).length ? rest : null);
      }
    });
  }

  ngOnInit(): void {
    this.isEdit = this.stepInput.isEdit;
    this.globalParams = this.stepInput.globalParams;
    this.isMediaPlan = this.stepInput.isMediaPlan;
    this.allowTemperatureTargeting = this.stepInput.allowTemperatureTargeting;
    this.allowWeatherTargeting = this.stepInput.allowWeatherTargeting;
    this.temperatureForm.get('temperatureMin').setValue(this.stepInput.temperatureMin);
    this.temperatureForm.get('temperatureMax').setValue(this.stepInput.temperatureMax);
    this.selectedCustomLocation = this.stepInput.customLocs;
    this.updateCustomLocationTable(this.allCustomLocation.length);
    this.selectedWeather = this.stepInput.selectedWeather;
    this.geoObject = this.stepInput.geoObject;
    this.geoOptimization = this.stepInput.geoOptimization;
    this.selectedZip = this.stepInput.postalCode ?? [];
    this.zip_action = this.stepInput.zip_action;
    this.getAllWeather();
    this.getGeoTab("country");
    if(this.stepInput.isBulkEdit){
      this.trgtOperations = JSON.parse(JSON.stringify(trgtOperationOptions)).slice(0,2);
      this.bulkEditTrgtAct = this.stepInput.bulkEditTrgtAct;
    }
    if (this.isEdit) {
      const postalCodes = this.stepInput.postalCode;
      if (Array.isArray(postalCodes) && postalCodes.length > 0) {
        this.selectedZip = [...postalCodes];
      } else {
        this.selectedZip = [];
      }
    }
  }

  maxGreaterValidator(group: FormGroup) {
    const minRaw = group.get('temperatureMin')?.value;
    const maxRaw = group.get('temperatureMax')?.value;
    const min = minRaw === null || minRaw === '' ? null : Number(minRaw);
    const max = maxRaw === null || maxRaw === '' ? null : Number(maxRaw);
    return max !== null && min !== null && max < min ? { maxLessThanMin: true } : null;
  }

  validateTemperature() {
    this.temperatureForm.updateValueAndValidity();
    this.proceed();
  }

  getAllWeather() {
    this.tdspLineItemService.getAllWeather(this.globalParams).subscribe((res) => {
      this.allAvailableWeather = res;
    });
  }

  setGeoData() {
    this.country_action = this.stepInput.country_action;
    this.region_action = this.stepInput.region_action;
    this.city_action = this.stepInput.city_action;
    this.metro_action = this.stepInput.metro_action;
    this.selectedMetro = this.stepInput.selectedMetro;
    // this.region_action = 'include';
    // this.country_action = 'include';
    // this.city_action = 'include';
    this.geoObject = this.stepInput.geoObject;
    this.proceed();
  }

  searchGeoData(event) {
    let filter = event.target.value.toLowerCase();
    let params: any = {
      fields: "name"
    };

    if (filter) {
      params.search_term = filter;
    }
    if (this.selectedGeoTab == "region") {
      if(this.geoFilter && this.geoFilter['GeoLocationType'] == 'Country'){
        params["country"] = this.geoFilter.GeoSegmentName.trim();
      }
      else if(this.geoObject.some(item => item.regions.length > 0)){
        params["region"] = this.geoObject.map(item => item.regions.map(region => region.region.name).join(",")).join(",");
      }
    }
    if (this.selectedGeoTab == "city") {
      if(this.geoFilter && this.geoFilter['GeoLocationType'] == 'Region'){
        params["region"] = this.geoFilter.GeoSegmentName.split("-").at(-1).trim();
        if( this.geoObject.length == 0 || this.geoObject.some(item => !item.country)) {
          params["country"] = this.geoFilter.GeoSegmentName.split("-").at(0).trim();
        }
      }
      if(this.geoObject.length > 0) {
        params["country"] = this.geoObject.map(item => item.country.name).join(",");
        if(this.geoObject.some(item => item.regions.length > 0)) {
          params["region"] = this.geoObject.map(item => item.regions.map(region => region.region.name).join(",")).join(",");
        }
      }
    }
    this.getGeoData(this.selectedGeoTab, 0, 100, false, params);
  }

  regionFilters(params = {}) {
    let country_ids = [];
    if (this.geoFilter) {
      country_ids.push(this.geoFilter.GeoSegmentName);
    } else {
      this.geoObject.forEach((c) => {
        if (c.country_included) country_ids.push(c.country.name);
      });
    }
    if (country_ids.length > 0) {
      // if (params["fields"]) {
      // params["fields"] += ",country_code_3";
      // } else {
      //   params["fields"] = "country_code_3";
      // }
      params["country"] = country_ids.join(",");
      // if (this.country_action == "exclude" && !this.geoFilter) {
      //   params["excludes"] = "country_code_3";
      // }
    }
    return params;
  }

  cityFilters(params = {}) {
    let region_ids = [];
    let country_ids = [];
    let region_filter_added: boolean = false;
    if (this.geoFilter && this.geoFilter.country_name) {
      region_ids.push(this.geoFilter.region_code);
      region_filter_added = true;
      country_ids.push(this.geoFilter.country_code_3);
    } else if (this.geoFilter) {
      country_ids.push(this.geoFilter.country_code_3);
    } else {
      this.geoObject.forEach((country) => {
        if (country.country_included) {
          country_ids.push(country.country.geo_id);
        }
        region_ids = region_ids.concat(
          country.regions.map((ele) => ele.region.geo_id.split("/")[1])
        );
      });
    }
    if (
      region_ids.length > 0 &&
      (this.country_action == "include" ||
        this.region_action == "exclude" ||
        region_filter_added)
    ) {
      if (params["fields"]) {
        params["fields"] += ",region_code";
      } else {
        params["fields"] = "region_code";
      }
      params["region_code"] = region_ids.join(",");
      if (
        this.region_action == "exclude" &&
        !(this.geoFilter && this.geoFilter.country_name)
      ) {
        params["excludes"] = "region_code";
      }
    }
    if (country_ids.length > 0) {
      if (params["fields"]) {
        params["fields"] += ",country_code_3";
      } else {
        params["fields"] = "country_code_3";
      }
      params["country_code_3"] = country_ids.join(",");
      if (this.country_action == "exclude" && !this.geoFilter) {
        if (params["excludes"]) {
          params["excludes"] += ",country_code_3";
        } else {
          params["excludes"] = "country_code_3";
        }
      }
    }

    return params;
  }

  getGeoName(row: any, selectedTab: string): string {
    const parts = row.GeoSegmentName?.split(' - ') || [];

    if (selectedTab === 'country') {
      return parts[0] || '';
    }
    else if (selectedTab === 'region') {
      return parts.slice(1).join(' - ');
    }
    else if (selectedTab === 'city') {
      return parts.length > 3 ? parts.slice(3).join(' - ') : parts.at(-1) || '';
    }

    return row.GeoSegmentName || '';
  }

  getRegionName(row: any): string {
    const parts = row.GeoSegmentName?.split(' - ') || [];

    // Case 1: Only 2 parts → return second part
    if (parts.length === 2) return parts[1];

    // Case 2: 3 parts → "Country - Region - City" → region is middle
    if (parts.length === 3) return parts[1];

    // Case 3: 4 or more → "Country - Region - City - Subcity" → region is 2nd part
    if (parts.length >= 4) return parts[1];

    // Fallback
    return '';
  }


  getGeoData(
    type: "country" | "region" | "city",
    start_element?,
    num_elements?,
    merge: boolean = false,
    params = {},
    isPostalCodesCall: boolean = false
  ) {
    this.setGeoData();
    if (type == "region") {
      params = this.regionFilters(params);
    }

    if(this.geoObject.length > 0 && !this.geoFilter) {
      params["country"] = this.geoObject.map(item => item.country.name).join(",");
    }
    params["type"] = type
    params = { ...params, ...this.search_params, ...this.stepInput.globalParams };
    type = null
    this.tdspStaticService
      .getStaticData(type, start_element, num_elements, params)
      .subscribe(
        (res) => {
          let geo: Array<any> = [];
          geo = res.results
          if(isPostalCodesCall){
            this.allCountriesForPostalCodes = res.results
            if (!params['search_term'] && this.ctryToTarget.length == 0) {
              this.ctryToTarget = res.results.map((country) => country.GeoSegmentName);
            }
          }
          if (merge) {
            this.allGeo = this.allGeo.concat(
              geo.map((e) => ({
                ...e,
                selected: false,
              }))
            );
            if (this.selectedGeoChip != "postal_codes") {
              this.pageLength = res.total;
              this.dataSourceGeo = new MatTableDataSource(this.allGeo);
              this.dataSourceGeo.paginator = this.paginatorGeo;
              this.dataSourceGeo.sort = this.sortGeo;
              this.dataSourceGeo._updatePaginator(this.pageLength);
            }
          } else {
            this.allGeo = geo.map((e) => ({
              ...e,
              selected: false,
            }));
            if (this.selectedGeoChip != "postal_codes") {
              this.pageLength = res.total;
              this.dataSourceGeo = new MatTableDataSource(this.allGeo);
              this.dataSourceGeo.paginator = this.paginatorGeo;
              this.dataSourceGeo.sort = this.sortGeo;
              this.dataSourceGeo._updatePaginator(this.pageLength);
              this.dataSourceGeo.paginator.firstPage();
            }
          }
        },
        () => { },
        () => { }
      );
  }

  getGeoTab(tab: "country" | "region" | "city") {
    this.selectedGeoTab = tab;
    this.search_params = {};
    let params = {};
    if (this.selectedGeoTab == "country") {
      this.displayColumnGeo = ["checkbox", "name"];
      this.geoFilter = null;
      this.geoSearchTerm = null;
    }
    if (this.selectedGeoTab == "region") {
      this.displayColumnGeo = ["checkbox", "name", "country_name"];
        this.geoSearchTerm = null;
      if(this.geoFilter && this.geoFilter['GeoLocationType'] == 'Country'){
        params["country"] = this.geoFilter.GeoSegmentName.trim();
      }
      else if(this.geoObject.some(item => item.regions.length > 0)){
        params["region"] = this.geoObject.map(item => item.regions.map(region => region.region.name).join(",")).join(",");
      }
    }
    if (this.selectedGeoTab == "city") {
      this.displayColumnGeo = [
        "checkbox",
        "name",
        "region_name",
        "country_name",
      ];
      if(this.geoFilter && this.geoFilter['GeoLocationType'] == 'Region'){
        params["region"] = this.geoFilter.GeoSegmentName.split("-").at(-1).trim();
        if( this.geoObject.length == 0 || this.geoObject.some(item => !item.country)) {
          params["country"] = this.geoFilter.GeoSegmentName.split("-").at(0).trim();
        }
      }
      if(this.geoObject.length > 0) {
        params["country"] = this.geoObject.map(item => item.country.name).join(",");
        if(this.geoObject.some(item => item.regions.length > 0)) {
          params["region"] = this.geoObject.map(item => item.regions.map(region => region.region.name).join(",")).join(",");
        }
      }
      this.geoSearchTerm = null;
    }
    this.getGeoData(tab,0,100,false,params);
  }

  getAllDma(params = {}, start_element?, num_elements?, merge = false) {
    // this.tdspStaticService
    //   .getStaticData("metros", start_element, num_elements, params)
    //   .subscribe((res) => {
    //     this.allMetro = res.metros.map((e) => ({
    //       ...e,
    //       selected: false,
    //     }));
    //     if (merge) {
    //       this.allGeo = this.allGeo.concat(this.allMetro);
    //       this.dataSourceMetro = new MatTableDataSource(this.allGeo);
    //       this.dataSourceMetro.paginator = this.paginatorMetro;
    //       this.dataSourceMetro.sort = this.sortMetro;
    //       this.dataSourceMetro._updatePaginator(this.dmaPageLength);
    //     } else {
    //       this.dmaPageLength = res.count;
    //       this.dataSourceMetro = new MatTableDataSource(this.allMetro);
    //       this.dataSourceMetro.paginator = this.paginatorMetro;
    //       this.dataSourceMetro.sort = this.sortMetro;
    //       this.dataSourceMetro._updatePaginator(this.dmaPageLength);
    //     }
    //   });
  }

  getGeoChip(value: "geo" | "dma" | "postal_codes" | "weather_temperature" | "custom_location") {
    this.selectedGeoChip = value;
    this.trgtOperations =
    value === "weather_temperature"
      ? JSON.parse(JSON.stringify(trgtOperationOptions))
      : JSON.parse(JSON.stringify(trgtOperationOptions)).slice(0, 2);
    if (value == "dma") {
      this.getAllDma();
    } else if (value == "geo") {
      this.getGeoTab("country");
    } else if (value == "custom_location") {
      this.getAllCustomLocation();
    } else if (value == "postal_codes") {
      this.getGeoData("country", 0, 100, false, {}, true);
    }
  }

  isIncluded(action_item) {
    return action_item == "" || action_item == "include";
  }

  isExcluded(action_item) {
    return action_item == "" || action_item == "exclude";
  }

  getFilteredGeo(geo) {
    let allowFilter: boolean = true;
    if (this.selectedGeoTab == "city") return;
    if (geo && geo.country_id) {
      this.geoObject.forEach((c) => {
        c.regions.forEach((r) => {
          if (r.region.geo_id == geo.id && this.region_action == "exclude")
            allowFilter = false;
        });
      });
    } else {
      this.geoObject.forEach((c) => {
        if (c.country.geo_id == geo.id && this.country_action == "exclude")
          allowFilter = false;
      });
    }
    if (allowFilter) {
      this.geoFilter = geo;
      if (this.selectedGeoTab == "country") {
        delete this.search_params["search_term"];
        this.getGeoTab("region");
      } else if (this.selectedGeoTab == "region") {
        delete this.search_params["search_term"];
        this.getGeoTab("city");
      }
    }
  }

  isIncludeGeo() {
    if (this.selectedGeoTab == "country") {
      return this.isIncluded(this.country_action);
    } else if (this.selectedGeoTab == "region") {
      let r_action = false;
      if (
        this.geoFilter &&
        !this.geoFilter.name &&
        this.geoObject.length > 0 &&
        this.country_action == "include"
      ) {
        this.geoObject.forEach((ele) => {
          if (ele.country.geo_id == this.geoFilter.GeoSegmentId && ele.country_included) {
            r_action = true;
          }
        });
      } else {
        r_action = this.isIncluded(this.region_action);
      }
      return r_action;
    } else if (this.selectedGeoTab == "city") {
      let c_action = false;
      if (
        this.geoFilter &&
        this.geoFilter.name &&
        this.geoObject.length > 0 &&
        this.country_action == "include"
      ) {
        this.geoObject.forEach((c) => {
          if (
            c.country_included
          ) {
            c_action = true;
          }
        });
      } else if (
        this.geoFilter &&
        !this.geoFilter.name &&
        this.geoObject.length > 0 &&
        this.country_action == "include"
      ) {
        this.geoObject.forEach((ele) => {
          if (
            ele.country_included
          ) {
            c_action = true;
          }
        });
      } else {
        c_action = this.isIncluded(this.city_action);
      }
      return c_action;
    }
  }

  isExcludeGeo() {
    if (this.selectedGeoTab == "country") {
      return this.isExcluded(this.country_action);
    } else if (this.selectedGeoTab == "region") {
      let r_action = false;
      if (
        this.geoFilter &&
        !this.geoFilter.name &&
        this.geoObject.length > 0 &&
        this.country_action == "include"
      ) {
        if (this.geoFilter.length == 0) r_action = true;
        this.geoObject.forEach((ele) => {
          if (ele.country.geo_id == this.geoFilter.GeoSegmentId && ele.country_included) {
            r_action = true;
          }
        });
      } else {
        r_action = this.isExcluded(this.region_action);
      }
      return r_action;
    } else if (this.selectedGeoTab == "city") {
      // let c_action = false;
      // if (
      //   this.geoFilter &&
      //   this.geoFilter.name &&
      //   this.geoObject.length > 0 &&
      //   this.country_action == "include"
      // ) {
      //   this.geoObject.forEach((c) => {
      //     if (
      //       c.country.geo_id == this.geoFilter.GeoSegmentId &&
      //       c.country_included
      //     ) {
      //       c_action = true;
      //     }
      //     // c.regions.forEach(reg => {
      //     //   if (reg.region.id == this.geoFilter.id && reg.region_included) {
      //     //     c_action = true
      //     //   }
      //     // })
      //   });
      // } else if (
      //   this.geoFilter &&
      //   !this.geoFilter.name &&
      //   this.geoObject.length > 0 &&
      //   this.country_action == "include"
      // ) {
      //   this.geoObject.forEach((ele) => {
      //     if (
      //       ele.country.geo_id == this.geoFilter.GeoSegmentId &&
      //       ele.country_included
      //     ) {
      //       c_action = true;
      //     }
      //   });
      // } else {
      //   c_action = this.isExcluded(this.city_action);
      // }
      return this.isExcluded(this.city_action);
    }
  }

  handlePageEvent(event: PageEvent) {
    this.pageLength = this.dmaPageLength = event.length;
    let requested_page = event.pageSize * (event.pageIndex + 1);
    let num_elements = 100;
    if (requested_page > 100) {
      let start_element = this.allGeo.length;
      if (this.selectedGeoChip == "dma") {
        this.getAllDma(this.search_params, start_element, num_elements, true);
      } else {
        let params = {};
        if(this.geoObject.length > 0) {
          params["country"] = this.geoObject.map(item => item.country.name).join(",");
          params["region"] = this.geoObject.map(item => item.regions.map(region => region.region.name).join(",")).join(",");
        }

        this.getGeoData(
          this.selectedGeoTab,
          start_element,
          num_elements,
          true,
          {...this.search_params, ...params}
        );
      }
    }
  }

  removeGeoFilter() {
    this.geoFilter = null;
    this.getGeoTab("country");
  }

  addGeo(row, action: 'include' | 'exclude') {
    if (!this.isMediaPlan) {
      if(this.selectedCustomLocation.length!=0) {
        this.dialog.open(ActionPreviewComponent, {
          width: "45em",
          disableClose: true,
          panelClass: "actionpreview-modalbox",
          data: {
            action:
              "Choose either geography-based targeting or custom location targeting",
              disablecancel: true
          },
        });
        return
      }
    }

    if (this.selectedGeoTab == 'country' && (this.country_action == '' || this.country_action == action)) {
      let country_obj = this.geoObject.find(ele => {
        const geoName = (row.GeoSegmentName || '').trim().toLowerCase();
        const geoNamePrefix = geoName.split(' - ')[0].trim().toLowerCase();
        const countryName = (ele.country.name || '').trim().toLowerCase();

        return countryName === geoName || countryName === geoNamePrefix;
      });

      if (!country_obj) {
        this.geoObject.push({
          country: { geo_id: row.GeoSegmentId, name: row.GeoSegmentName },
          country_included: true,
          regions: [],
          bid_factor: action == 'include' ? 1.00 : 0
        })
        this.country_action = action;
      } else {
        if (action == 'exclude') {
          let dont_allow_save: boolean = false;
          country_obj.regions.forEach(reg => {
            if (reg.region_included && this.region_action == 'include') {
              dont_allow_save = true;
            } else if (reg.cities.length > 0 && this.city_action == 'include') {
              dont_allow_save = true;
            }
          })
          if (!dont_allow_save) {
            country_obj.country_included = true;
            this.country_action = action;
            // if (row.name == 'United States') {
            //   this.united_states_selected = true;
            // }
          }
        } else {
          country_obj.country_included = true;
          this.country_action = action;
          // if (row.name == 'United States') {
          //   this.united_states_selected = true;
          // }
        }
      }
    } else if (this.selectedGeoTab == 'region' && (this.region_action == '' || this.region_action == action)) {
      let region_obj = {
        region: { geo_id: row.GeoSegmentId, name: row.GeoSegmentName.split(' - ').at(-1), country_name: row.GeoSegmentName.split(' - ').at(0) },
        region_included: true,
        cities: [],
        bid_factor: action == 'include' ? 1.00 : 0
      }
      let country_obj = this.geoObject.find(ele => {
        const geoName = (row.GeoSegmentName || '').trim().toLowerCase();
        const geoNamePrefix = geoName.split(' - ')[0].trim().toLowerCase();
        const countryName = (ele.country.name || '').trim().toLowerCase();

        return countryName === geoName || countryName === geoNamePrefix;
      });
      if (country_obj) {
        // let r_obj = country_obj.regions.filter(ele => ele.region.id == row.id)[0]
        const regionName = ((row.GeoSegmentName || '')
          .split(' - ')[1] || '')
          .trim()
          .toLowerCase();

        const r_obj = country_obj?.regions?.find(
          ele => (ele.region.name || '').trim().toLowerCase() === regionName
        );

        if (!r_obj) {
          country_obj.regions.push(region_obj)
          this.region_action = action;
        } else {
          if (action == 'exclude') {
            let dont_allow_save: boolean = false;
            if (r_obj.cities.length > 0 && this.city_action == 'include') {
              dont_allow_save = true;
            }
            if (!dont_allow_save) {
              r_obj.region_included = true;
              this.region_action = action;
            }
          } else {
            r_obj.region_included = true;
            this.region_action = action;
          }
        }
      } else {
        this.geoObject.push({
          country: { geo_id: row.country_id, name: row.GeoSegmentName.split(' - ').at(-2) },
          country_included: false,
          regions: [region_obj],
          bid_factor: action == 'include' ? 1.00 : 0
        })
        this.region_action = action;
      }
    } else if (this.selectedGeoTab == 'city' && (this.city_action == '' || this.city_action == action)) {
      this.city_action = action;
      let country_obj = this.geoObject.find(ele => {
        const geoName = (row.GeoSegmentName || '').trim().toLowerCase();
        const geoNamePrefix = geoName.split(' - ')[0].trim().toLowerCase();
        const countryName = (ele.country.name || '').trim().toLowerCase();
        return countryName === geoName || countryName === geoNamePrefix;
      });
      if (country_obj) {
        const regionName = ((row.GeoSegmentName || '')
          .split(' - ')[1] || '')
          .trim()
          .toLowerCase();

        const region_obj = country_obj?.regions?.find(
          ele => (ele.region.name || '').trim().toLowerCase() === regionName
        );

        if (region_obj) {
          const cityName = (row.GeoSegmentName || '').split(' - ').at(-1)?.trim().toLowerCase() || '';
          if (!region_obj?.cities?.some(ele => (ele.name || '').trim().toLowerCase() === cityName)) {
            region_obj.cities.push({
              geo_id: row.GeoSegmentId,
              name: cityName.charAt(0).toUpperCase() + cityName.slice(1), // Titlecase city name
              bid_factor: action == 'include' ? 1.00 : 0,
              country_name: row.GeoSegmentName.split(' - ').at(0),
              region_name: row.GeoSegmentName.split(' - ').at(1)
            });
          }

        } else {
          country_obj.regions.push({
            region: { geo_id: row.region_id, name: row.GeoSegmentName.split(' - ').at(-2) },
            region_included: false,
            cities: [{ geo_id: row.GeoSegmentId, name: row.GeoSegmentName.split(' - ').at(-1), bid_factor: action == 'include' ? 1.00 : 0,
               country_name: row.GeoSegmentName.split(' - ').at(0), region_name: row.GeoSegmentName.split(' - ').at(1) }],
            bid_factor:  action == 'include' ? 1.00 : 0
          })
        }
      } else {
        this.geoObject.push({
          country: { geo_id: row.country_id, name: row.GeoSegmentName.split(' - ').at(-3) },
          country_included: false,
          regions: [{
            region: { geo_id: row.region_id, name: row.GeoSegmentName.split(' - ').at(-2) },
            region_included: false,
            cities: [{ geo_id: row.GeoSegmentId, name: row.GeoSegmentName.split(' - ').at(-1), bid_factor:  action == 'include' ? 1.00 : 0,
               country_name: row.GeoSegmentName.split(' - ').at(0), region_name: row.GeoSegmentName.split(' - ').at(1) }],
            bid_factor:  action == 'include' ? 1.00 : 0
          }],
          bid_factor:  action == 'include' ? 1.00 : 0
        })
      }
    }
    this.proceed();
  }

  removeCountry(index) {
    this.geoObject.splice(index, 1);
    let reset_country_action: boolean = true;
    if (this.geoObject.length == 0) {
      this.region_action = "";
      this.city_action = "";
      this.country_action = "";
    }
    this.geoObject.forEach((c) => {
      if (c.country_included) {
        reset_country_action = false;
      }
    });
    if (
      reset_country_action
    ) {
      this.country_action = "";
    }
    this.proceed();
  }

  removeRegion(country_index, region_index) {
    this.geoObject[country_index].regions.splice(region_index, 1);
    if (
      !this.geoObject[country_index].country_included &&
      this.geoObject[country_index].regions.length == 0
    ) {
      this.removeCountry(country_index);
    }
    let regions = [];
    let cities = [];
    this.geoObject.forEach((country) => {
      country.regions.forEach((reg) => {
        if (reg.region_included) {
          regions.push(reg.region);
        }
        cities = cities.concat(reg.cities);
      });
    });
    if (regions.length == 0) {
      this.region_action = "";
    }
    if (cities.length == 0) {
      this.city_action = "";
    }
    this.proceed();
  }

  removeCity(country_index, region_index, city_index) {
    this.geoObject[country_index].regions[region_index].cities.splice(
      city_index,
      1
    );
    if (
      !this.geoObject[country_index].regions[region_index].region_included &&
      this.geoObject[country_index].regions[region_index].cities.length == 0
    ) {
      this.removeRegion(country_index, region_index);
    }
    let cities = [];
    this.geoObject.forEach((country) => {
      country.regions.forEach((region) => {
        cities = cities.concat(region.cities);
      });
    });
    if (cities.length == 0) {
      this.city_action = "";
    }
    this.proceed();
  }

  removeAllGeo() {
    this.geoObject.splice(0, this.geoObject.length);
    this.region_action = "";
    this.city_action = "";
    this.country_action = "";
    this.proceed();
  }

  searchDma(event) {
    let filter = event.target.value.toLowerCase();
    let isCode = Number.isFinite(parseInt(filter));
    let params;
    if (isCode && filter.length >= 3) {
      params = {
        fields: "key",
        key: filter,
      };
      this.getAllDma(params);
    }
    if (!isCode) {
      params = {
        fields: "name",
        name: filter,
      };
      this.getAllDma(params);
    }
  }

  removeAllDma() {
    this.selectedMetro = [];
    this.metro_action = "";
    this.proceed();
  }

  addDma(item, action) {
    if (
      (this.metro_action == "" || this.metro_action == action) &&
      !this.selectedMetro.filter((e) => e.key == item.key)[0]
    ) {
      this.selectedMetro.push(item);
      this.metro_action = action;
    }
    this.proceed();
  }

  removeDma(item) {
    this.selectedMetro = this.selectedMetro.filter((e) => e.key !== item.key);
    this.selectedMetro.length == 0
      ? (this.metro_action = "")
      : this.metro_action;
    this.proceed();
  }

  clearAllTextFromPostalTextArea() {
    this.inputZipCodes = null;
  }

  getInputOfIds(id: string) {
    let separatedIds = id
      .split(/[,|\n]/)
      .map((e) => e.trim())
      .filter((e) => e != "");
    return separatedIds;
  }

  applyFilterCountryForPostalCodes(event) {
    let search = event.target.value.toLowerCase();
    let param = {
      // 'search_fields': 'name',
      'search_term': search
    }
    this.getGeoData('country', 0, 100, false, param, true)
  }

  addPostalCodes() {
    if (!this.isMediaPlan) {
      if(this.selectedCustomLocation.length!=0){
        this.dialog.open(ActionPreviewComponent, {
          width: "45em",
          disableClose: true,
          panelClass: "actionpreview-modalbox",
          data: {
            action:
              "Choose either geography-based targeting or custom location targeting",
              disablecancel: true
          },
        });
        return
      }
    }

    if (this.inputZipCodes) {
      let postalCodes = new Set(this.getInputOfIds(this.inputZipCodes));
      let unique_postalCodes = Array.from(postalCodes);
      let codes = {
        postal_codes: unique_postalCodes,
        country: this.selectedCountryIDForPostalCodes,
      };
      this.geoService.validatePostalCodes(codes, this.stepInput.globalParams).subscribe((res) => {
        // Convert only new valid results
        const transformedValid = res.valid.map(zip => ({
          geo_id: zip.GeoSegmentId,
          code: zip.GeoSegmentName.split('-').at(-1).trim()
        }));

        // Merge with already formatted existing zips
        this.selectedZip = this.commonService.getDistinctArrayOfObjects([
          ...this.selectedZip,
          ...transformedValid
        ]);

        // Handle invalid postal codes
        const invalidPostalCodes = res.invalid;
        if (invalidPostalCodes.length) {
          this.dialog.open(InformationBoxComponent, {
            width: '65em',
            autoFocus: false,
            disableClose: true,
            data: {
              type: 'postalCodeValidation',
              inactivePostalCodes: [],
              invalidPostalCodes
            },
            panelClass: 'information-modalbox'
          });
        }

        this.inputZipCodes = invalidPostalCodes.join(',');
        this.proceed();
      });

      this.inputZipCodes = null;
      this.proceed();
    }
  }

  removeAllPostalCodes() {
    this.selectedZip = [];
    this.proceed();
  }

  removeSelectedPostalCodes(index) {
    this.selectedZip.splice(index, 1);
    this.proceed();
  }

  updatePostalCodeAction(type) {
    this.zip_action = type;
    this.proceed();
  }

  checkOperation(type, value = null) {
     if (type === "country") {
      this.bulkEditTrgtAct["region"] = value;
      this.bulkEditTrgtAct["city"] = value;
    }
    switch (type) {
      case "country":
        if (this.bulkEditTrgtAct.country == "remove_all") {
          this.removeAllGeo();
        }
        break;
      case "zip":
        if (this.bulkEditTrgtAct.zip == "remove_all") {
          this.removeAllPostalCodes();
        }
        break;
    }
  }

  proceed() {
    let obj = {
      country_action: this.country_action,
      region_action: this.region_action,
      city_action: this.city_action,
      geoObject: this.geoObject,
      zip_action: this.zip_action,
      metro_action: this.metro_action,
      selectedMetro: this.selectedMetro,
      selectedZip: this.selectedZip,
      customLocs: this.customLocs,
      temperatureMin: this.temperatureForm.get('temperatureMin').value,
      temperatureMax: this.temperatureForm.get('temperatureMax').value,
      selectedWeather: this.selectedWeather,
      geoOptimization: this.geoOptimization,
      selectedCustomLocation: this.selectedCustomLocation
    };
    this.commonService.setGeographyData(obj);
  }

  getAllCustomLocation(params = {}, start_element = 0, num_elements = 100, merge = false) {
    params['start_element'] = start_element;
    params['num_elements'] = num_elements;
    params['status'] = 'completed';
    if(this.search_custom_location_params)
    params={...params, ...this.search_custom_location_params, ...this.globalParams};
    this.customLocationService.list(params).subscribe((res) => {
      if (merge) {
        this.allCustomLocation = this.allCustomLocation.concat(res.data);
        this.updateCustomLocationTable(this.pageLengthCustomLocation);
      } else {
        this.allCustomLocation = res.data;
        this.pageLengthCustomLocation = this.totalCustomLocationCount = res.count;
        this.updateCustomLocationTable(this.totalCustomLocationCount);
      }
      if (this.selectedCustomLocation.length > 0) {
        this.selectedCustomLocation.forEach(seller => {
          this.allCustomLocation = this.allCustomLocation.filter(ele => ele.id != seller.id)
        })
        this.pageLengthCustomLocation = this.totalCustomLocationCount - this.selectedCustomLocation.length;
        this.updateCustomLocationTable(this.pageLengthCustomLocation);
      }
    });
  }

  updateCustomLocationTable(tableCount) {
    this.dataSourceCustomLocation = new MatTableDataSource(this.allCustomLocation);
    this.dataSourceCustomLocation.paginator = this.paginatorCustomLocation;
    this.dataSourceCustomLocation.sort = this.sortCustomLocation;
    this.dataSourceCustomLocation._updatePaginator(tableCount);
    this.proceed();
  }

  addCustomLocationItem(item, event) {
    if(this.geoObject.length!=0 || this.selectedZip.length != 0){
      (event.target as HTMLInputElement).checked =false
      this.dialog.open(ActionPreviewComponent, {
        width: "45em",
        disableClose: true,
        panelClass: "actionpreview-modalbox",
        data: {
          action:
            "Choose either geography-based targeting or custom location targeting.",
            disablecancel: true
        },
      });
      return
    }
    this.geoOptimization = false;
    if (this.selectedCustomLocation.length > 0) {
      this.allCustomLocation.unshift(this.selectedCustomLocation[0]);
      this.selectedCustomLocation.length = 0;
      this.pageLengthCustomLocation = this.pageLengthCustomLocation + 1;
    }
    this.selectedCustomLocation.push(item);
    this.allCustomLocation = this.allCustomLocation.filter((e) => item.id != e.id);
    this.pageLengthCustomLocation = this.pageLengthCustomLocation - 1;
    this.updateCustomLocationTable(this.allCustomLocation.length);
  }

  removeCustomLocationItem(item) {
    this.allCustomLocation.unshift(item);
    this.selectedCustomLocation= this.selectedCustomLocation.filter((e) => item.id != e.id);
    this.pageLengthCustomLocation = this.pageLengthCustomLocation + 1;
    this.updateCustomLocationTable(this.pageLengthCustomLocation);
  }

  removeAllCustomLocationItem() {
    this.allCustomLocation = this.allCustomLocation.concat(this.selectedCustomLocation);
    this.selectedCustomLocation = [];
    this.pageLengthCustomLocation = this.totalCustomLocationCount;
    this.updateCustomLocationTable(this.pageLengthCustomLocation);
  }

  searchCustomLocation(event) {
    const filterValue = (event.target as HTMLInputElement).value;
    if (filterValue.length >= 3) {
      this.search_custom_location_params['search_term'] = filterValue
      this.getAllCustomLocation();
    } else if (filterValue.length == 0) {
      this.search_custom_location_params = {};
      this.getAllCustomLocation();
    }
  }

  avlCtryForTar() {
    this.commonService.displayAvlCountry(this.ctryToTarget);
  }

}
